import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHourglassEmptyStyle0 = cosmosIconCss;

const CosmosIconHourglassEmpty$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHourglassEmpty extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '14933d0fe6957046c4b5878c72e2a805b261cf1c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6131280f33558ee552f03349cff77455e39aa3f5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '63a2bcbbbe424c9345becfb59cffdda2a090727a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 5.06V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v1.56c0 2.68 1.77 4.17 3.67 5.49-1.89 1.35-3.67 3-3.67 6v1.95a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1.94c0-3-1.78-4.66-3.67-6C14.23 9.23 16 7.74 16 5.06ZM14.36 15.5H7.65c.39-1.82 1.77-3 3.35-4.05 1.58 1.09 3 2.23 3.36 4.05ZM11 9.64C9.1 8.35 7.5 7.19 7.5 5.06v-.55h7v.55c0 2.13-1.6 3.29-3.5 4.58Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHourglassEmptyStyle0; }
}, [1, "cosmos-icon-hourglass-empty", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-hourglass-empty"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-hourglass-empty":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHourglassEmpty$1);
            }
            break;
    } });
}

const CosmosIconHourglassEmpty = CosmosIconHourglassEmpty$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHourglassEmpty, defineCustomElement };
